import React, { useState, useMemo } from "react";
import { oneDecimalWithPercentage } from "./utils";
import { ChartDownsampled } from "./Chart";
import { getAllItems } from "./utils";
import ColumnsGrid from "common/layouts/ColumnsGrid";

const congestionGraphSpecs = [
  {
    title: "Total Throughput Downlink",
    fields: [{ name: "Dn", label: "Mbps-downlink" }],
    yAxisUnits: "Mbps",
    yTooltipFormat: (d) =>
      d === undefined || d === null ? undefined : `${d} Mbps`,
    result: "throughput",
  },
  {
    title: "Total Throughput Uplink",
    fields: [{ name: "Up", label: "Mbps-Uplink" }],
    yAxisUnits: "Mbps",
    yTooltipFormat: (d) =>
      d === undefined || d === null ? undefined : `${d} Mbps`,
    result: "throughput",
  },
  {
    title: "Latency Over Time",
    fields: [
      {
        name: "Rtt-80%-Dn-Ms",
        label: "P80-80th percentile",
        tooltip:
          "The 80-th percentile of all downlink RTT latency, measured from BQN to end user, in 5 minutes.",
      },
      {
        name: "Rtt-Med-Dn-Ms",
        label: "P50-Median",
        tooltip:
          "The 50-th percentile (median) of all downlink RTT latency samples, measured from BQN to end user, in 5 minutes.",
      },
      {
        name: "Rtt-Min-Dn-Ms",
        label: "Mean-Min",
        tooltip:
          "The mean of all downlink RTT minimum latency samples, measured in 1-second intervals, during active downloads, in 5 minutes.",
      },
    ],
    yAxisUnits: "milliseconds",
    yTooltipFormat: (d) =>
      d === undefined || d === null ? undefined : `${d} ms`,
    result: "latency",
  },
  {
    title: "Average traffic under congestion",
    fields: [{ name: "congested", label: "Congested-traffic-%" }],
    yAxisUnits: "% of total traffic",
    yTooltipFormat: oneDecimalWithPercentage,
    result: "congestion",
  },
  {
    title: "Average TCP Retransmissions Over Time",
    fields: [{ name: "Rtx%-Access", label: "Retransmissions-%" }],
    yAxisUnits: "retransmissions-%",
    yTooltipFormat: oneDecimalWithPercentage,
    result: "retransmission",
  },
  {
    title: "Average traffic with ACM",
    fields: [{ name: "acm", label: "ACM-%" }],
    yAxisUnits: "% of total traffic",
    yTooltipFormat: oneDecimalWithPercentage,
    result: "congestion",
  },
];

const Charts = (props) => {
  const [interactionData, setInteractionData] = useState(null);
  const { range, hours, congestion, latency, retransmission, throughput } = props;
  const extendedItems = useMemo(
    () => range ? getAllItems({ congestion, latency, retransmission, throughput }, range) || {} : {},
    [range, congestion, latency, retransmission, throughput]
  );

  return (
    <ColumnsGrid columns={2} minWidth="7cm" gap="0px">
      {congestionGraphSpecs.map(
        ({ title, fields, result, yAxisUnits, yTooltipFormat }, index) => (
          <div key={`chart-${result}-${index}`}>
            <ChartDownsampled
              title={title}
              fields={fields}
              hours={hours}
              items={extendedItems[result] || []}
              yAxisUnits={yAxisUnits}
              yTooltipFormat={yTooltipFormat}
              range={range}
              interactionData={interactionData}
              setInteractionData={setInteractionData}
              loading={props.loading}
              type={result}
            />
          </div>
        ),
      )}
    </ColumnsGrid>
  );
};

export default Charts;
